import { type ExperimentsResponse } from './experiments.types';

export const MOCK_EXPERIMENTS: ExperimentsResponse['features'] = {};
